import { Link } from "@heroui/react";
import { Section } from "@/shared/ui/section";
import { Footer } from "@/widgets/footer";
import { Header } from "@/widgets/header";

/**
 * Policy page
 * @returns {ReactNode}
 * @constructor
 */
export const Policy = () => {
  return (
    <>
      <Header isDefaultBlurred={true} />
      <main className={"pageLayout__main bg-[var(--color-bege)]"}>
        <Section utilClasses={[ "bg-[var(--color-white)]" ]} extraClasses={{ isPtLargeMobile: true }}>
          <div className={"content"}>
            <h1 className={"mb-11 mobile:mb-8"}>Privacy Policy</h1>
            <h2 className={"h3 h3 mb-8 mobile:mb-5"}>Introduction</h2>
            <p className={"mb-13 mobile:mb-8"}>DeepSum: YouTube AI Summary ("DeepSum," "we," "us," or "our") values the privacy of our users ("user" or "you"). This Privacy Policy outlines how we collect, use, and safeguard your information when you use our Chrome Extension. By using the <Link href={"https://chromewebstore.google.com/detail/cpojeidlghjghloilgkgdeoielaebfmo?utm_source=item-share-cb"} target={"_blank"} rel={"noreferrer"} className={"!underline underline-offset-4"}>Chrome Extension</Link>, you consent to the data practices described in this policy.</p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Information We Collect</h2>
            <p className={"mb-2"}>
              We collect information in the following ways:
            </p>
            <p className={"mb-1"}>
              <b>Personal Data:</b> We collect your name and email address when you register or interact with our services.
            </p>
            <p className={"mb-1"}>
              <b>Derivative Data:</b> Automatically collected information includes your IP address, browser type, operating system, and access times.
            </p>
            <p className={"mb-13 mobile:mb-8"}>
              <b>App Usage Data:</b> We monitor how you use our application to enhance our services.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Use of Information</h2>
            <p className={"mb-13 mobile:mb-8"}>Your information is used to manage your account, produce anonymized analytics, and ensure the functionality of our services.</p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Cookies and Tracking Technologies</h2>
            <p className={"mb-13 mobile:mb-8"}>
              Cookies are used to facilitate the core functions of our Site and services. The YouTube embedded player uses the only third-party cookie on our Site.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Data Retention</h2>
            <p className={"mb-13 mobile:mb-8"}>
              We retain your personal information for as long as it is necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Data Security</h2>
            <p className={"mb-13 mobile:mb-8"}>
              We implement a variety of security measures to maintain the safety of your personal information. While we strive to protect your information, no security measures can guarantee absolute protection.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Your Choices and Rights</h2>
            <p className={"mb-13 mobile:mb-8"}>
              You have the right to review, change, or delete your personal information by emailing us at <Link href={"mailto:deepsumx@gmail.com"} className={"!underline underline-offset-4"}>deepsumx@gmail.com</Link>.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Changes to This Privacy Policy</h2>
            <p className={"mb-13 mobile:mb-8"}>
              We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Effective Date" and will be effective as soon as it is accessible. We encourage you to review this Privacy Policy periodically to stay informed of our privacy practices.
            </p>

            <h2 className={"h3 mb-8 mobile:mb-5"}>Contact Us</h2>
            <p className={"mb-13 mobile:mb-8"}>
              For any questions or comments about this Privacy Policy, please contact us at:
              Email: <Link href={"mailto:deepsumx@gmail.com"} className={"!underline underline-offset-4"}>deepsumx@gmail.com</Link>
            </p>
          </div>
        </Section>
      </main>
      <Footer />
    </>
  );
};
